export default __webpack_public_path__ + "static/media/background.7a98a3bd.png";